import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';

@Injectable()
export class UserService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public override listAll(filter: any = {}): Observable<any> {
    let params = {
      ...{ getRelation: 1, limit: 36, page: 0, filter: '' },
      ...filter,
    };
    return this.httpClient.get<any>(`${API_PATH}${this.relativeUrl}`, {
      params,
    });
  }

  public adminResetPassword(
    id: string,
    payload: {
      generatePassword?: boolean;
      newPassword?: string;
      confirmPassword?: string;
      requireChangePassword?: boolean;
    }
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${API_PATH}${this.relativeUrl}/admin-reset-password/${id}`,
      payload
    );
  }

  public resetPassword(partnerId: string) {
    return this.httpClient.put(
      `${API_PATH}${this.relativeUrl}/reset-password-by-partner/${partnerId}`,
      {}
    );
  }

  public generateAcessToPartner(partnerId: string): Observable<any> {
    return this.httpClient.put<any>(
      `${API_PATH}${this.relativeUrl}/generate-access-to-partner/${partnerId}`,
      {}
    );
  }

  public syncMerchantUserGroups(): Observable<any> {
    return this.httpClient.put<any>(
      `${API_PATH}${this.relativeUrl}/sync-merchant-user-groups`,
      {}
    );
  }

  public listBranchOptions(): Observable<{ options: any[]; selectedBranchId: string | null }> {
    return this.httpClient.get<{ options: any[]; selectedBranchId: string | null }>(
      `${API_PATH}${this.relativeUrl}/branch-options`
    );
  }

  /**
   * Permissões granulares do PRÓPRIO usuário autenticado (self, via req.user no
   * backend) — usado só pela tela de Perfil, somente leitura. Espelha
   * `UserMyPermissionsService.listMyPermissions` do ABCX. Diferente de
   * `UserPermissionService.listAll({user:id})` (endpoint ADMIN, gateado por
   * `UserPermissionsController_findAll` — não serve pra autoconsulta de quem
   * não gerencia permissões de outros usuários).
   */
  /**
   * Perfil do PROPRIO usuario da sessao: `GET /users/me` (self, usuario do token — sem id na rota).
   * Substitui o `GET /users/:id` na tela de perfil: aquele serve qualquer usuario e nao faz parte do minimo.
   */
  public getMe(): Observable<any> {
    return this.httpClient.get<any>(`${API_PATH}${this.relativeUrl}/me`);
  }

  /** Troca a PROPRIA senha: `PUT /users/me/password` (self; exige a senha atual). */
  public updateMyPassword(object: Object): Observable<void> {
    return this.httpClient.put<void>(`${API_PATH}${this.relativeUrl}/me/password`, object);
  }

  public getMyPermissions(): Observable<any> {
    return this.httpClient.get<any>(
      `${API_PATH}${this.relativeUrl}/my-permissions`
    );
  }
}
